import { Badge } from "@/components/ui/badge";

// Repeated form-grid layout classes (identical rendering, named once).
export const FORM_GRID_2 = "grid grid-cols-2 gap-3";
export const FORM_GRID_3 = "grid grid-cols-3 gap-3";

export const STAGE_STYLES = {
  "New Lead": "bg-[#3B82F6]/10 text-[#1D4ED8]",
  "Qualified": "bg-[#06B6D4]/10 text-[#0E7490]",
  "Discovery / Needs Analysis": "bg-[#8B5CF6]/10 text-[#6D28D9]",
  "Proposal": "bg-[#F59E0B]/10 text-[#B45309]",
  "Negotiation": "bg-[#F97316]/10 text-[#C2410C]",
  "Closed - Won": "bg-[#569A1F]/15 text-[#457d18]",
  "Closed - Lost": "bg-[#EF4444]/10 text-[#B91C1C]",
};

export function StageBadge({ name, testId }) {
  if (!name) return null;
  return (
    <Badge data-testid={testId}
      className={`rounded-sm border-0 text-xs font-semibold hover:bg-transparent ${STAGE_STYLES[name] || "bg-[#F4F4F5] text-[#52525B]"}`}>
      {name}
    </Badge>
  );
}

export function OutcomeBadge({ outcome }) {
  if (outcome === "won") {
    return <Badge className="rounded-sm border-0 bg-[#569A1F] text-xs font-bold text-white hover:bg-[#569A1F]" data-testid="outcome-badge">Won</Badge>;
  }
  if (outcome === "lost") {
    return <Badge className="rounded-sm border-0 bg-[#EF4444] text-xs font-bold text-white hover:bg-[#EF4444]" data-testid="outcome-badge">Lost</Badge>;
  }
  if (outcome === "open") {
    // Red cue applies within Opportunity displays only — never at the organization level.
    return <Badge className="rounded-sm border-0 bg-[#EF4444]/10 text-xs font-bold text-[#B91C1C] hover:bg-[#EF4444]/10" data-testid="outcome-badge">Active</Badge>;
  }
  return null;
}

export function money(n) {
  if (n == null) return "—";
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

// Mirror of the server calculation, for live form previews only.
// The server value is always authoritative.
export function preview12Month(mrr, oneTime, term) {
  const t = Number(term);
  const months = t > 0 ? Math.min(t, 12) : 12;
  return (Number(mrr) || 0) * months + (Number(oneTime) || 0);
}

// Total Contract Value — full signed term, informational only (never quota/commission).
export function previewTCV(mrr, oneTime, term) {
  const t = Number(term);
  if (!(Number(mrr) > 0) || !(t > 0)) return null;
  return Number(mrr) * t + (Number(oneTime) || 0);
}
